export default function withTimeout(promise, ms, timeoutErrorHandler) {
    const timeout = new Promise((_, reject) => {
        const id = setTimeout(() => {
            clearTimeout(id);
            reject(timeoutErrorHandler());
        }, ms);
    });
    return Promise.race([promise, timeout]);
}
//# sourceMappingURL=timeout-promise.js.map